import { useCallback, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useAppSelector } from "JS/Redux/Store";
import { PaymentEligibleUsersService } from "JS/Services/PaymentEligibleUsers";
import { setGlobalPaymentEligibleUsers } from "JS/Redux/PaymentEligibleUsers";

export const service = new PaymentEligibleUsersService();

export const usePaymentEligibleUsers = (skip: boolean = true) => {
    const [loading, setLoading] = useState(false);
    const [response, setResponse] = useState<string[]>();
    const { setGlobalPaymentEligibleUsersState } =
        useGlobalPaymentEligibleUsers();

    const refetch = useCallback(() => {
        setLoading(true);
        return service
            .getPaymentEligibleUsers()
            .then(async (res) => {
                setGlobalPaymentEligibleUsersState(res);
                setResponse(res);
                return res;
            })
            .catch((err) => {
                return null;
            })
            .finally(() => {
                setLoading(false);
            });
    }, []);

    useEffect(() => {
        if (!skip) refetch();
    }, [skip]);

    return {
        refetch,
        response,
        loading,
    };
};

export const useGlobalPaymentEligibleUsers = () => {
    const dispatch = useDispatch();

    const paymentEligibleUsers = useAppSelector(
        (state) => state.paymentEligibleUsers,
    );

    return {
        paymentEligibleUsers,
        setGlobalPaymentEligibleUsersState: (payload: string[]) => {
            dispatch(setGlobalPaymentEligibleUsers(payload));
        },
    };
};
